import { getXtremePush } from '../../xtreme-push/utils/use-xtreme-push';
import type { IEvent } from '../interfaces/events.interface';
import { EventName } from '../interfaces/events.interface';

export async function xtremePushEventListener(event: IEvent) {
    switch (event.name) {
        case EventName.WINDOW_RESIZE:
            return;
        case EventName.USER_PROFILE_UPDATE:
            (await getXtremePush())('event', 'USER_PROFILE_UPDATE');
            return;
        case EventName.USER_DEPOSIT:
            (await getXtremePush())('event', 'USER_DEPOSIT', {
                amount: event.amount,
                currency: event.currency,
            });
            return;
        case EventName.USER_WITHDRAWAL:
            (await getXtremePush())('event', 'USER_WITHDRAWAL', {
                amount: event.amount,
                currency: event.currency,
            });
            return;
        case EventName.LOGIN_REQUEST:
            (await getXtremePush())('event', 'LOGIN_REQUEST');
            return;
        case EventName.LOGOUT_REQUEST:
            (await getXtremePush())('event', 'LOGOUT_REQUEST');
            return;
        case EventName.NAVIGATE:
            //(await getXtremePush())('event', 'NAVIGATION', event.path);
            return;
        case EventName.UPLOAD_DOCUMENT_KYC_ATTEMPT:
            (await getXtremePush())('event', 'UPLOAD_DOCUMENT_KYC_ATTEMPT');
            return;
        case EventName.UPLOAD_DOCUMENT_KYC_SUCCESS:
            (await getXtremePush())('event', 'UPLOAD_DOCUMENT_KYC_SUCCESS');
            return;
        case EventName.UPLOAD_DOCUMENT_KYC_FAILED:
            (await getXtremePush())('event', 'UPLOAD_DOCUMENT_KYC_FAILED');
            return;
        case EventName.RG_SUBMITTED:
            (await getXtremePush())('event', 'RG_SUBMITTED', { Period: event.period });
            return;
    }
}
